function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 152.63 147.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "firmament-fileAsset 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8.31,
    y1: 8.65,
    x2: 84.31,
    y2: 81.65,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 24
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.31,
    y1: 8.65,
    x2: 68.31,
    y2: 81.65,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 24
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.31,
    y1: 138.65,
    x2: 84.31,
    y2: 65.65,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 24
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.31,
    y1: 138.65,
    x2: 68.31,
    y2: 65.65,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 24
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a0a47b6ff1ee03eebd0ea7a1c2ebdd5d.svg";
export { ForwardRef as ReactComponent };